import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useGetGymByIdQuery, useUpdateGymMutation } from "../slices/gymSlice";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Col, ListGroup, Row, Form } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import ReUsableModal from "../components/ReUsableModal";
import { Pencil } from "react-bootstrap-icons";
import { toast } from "react-toastify";

const GymProfileScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { gymId } = useParams();
  const navigate = useNavigate();
  const [deviceIds, setDeviceIds] = useState("");
  const [gymStatus, setGymStatus] = useState("");
  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);

  const {
    data: gym,
    isLoading,
    refetch,
    error,
  } = useGetGymByIdQuery({
    token: userInfo.token,
    gymId,
  });

  const [updateGym, { isLoading: updating }] = useUpdateGymMutation();

  const handleEdit = () => {
    const ids = gym?.gymId?.boxtelDeviceIds?.join(", ") || "";
    //  console.log("ids =", ids);
    setDeviceIds(ids);
    // console.log("after setDeviceIds =", ids);
    setShowDeviceModal(true);
  };

  const handleStatusEdit = () => {
    setGymStatus(gym?.gymId?.gymStatus);
    setShowStatusModal(true);
  };

  const handleSubmit = async () => {
    try {
      await updateGym({
        token: userInfo.token,
        gymId,
        payload: {
          boxtelDeviceIds: deviceIds
            .split(",")
            .map((id) => id.trim())
            .filter(Boolean),
        },
      }).unwrap();
      refetch();
      toast.success("Biometric Device Id updated successfully");
      setShowDeviceModal(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleStatusSubmit = async () => {
    try {
      await updateGym({
        token: userInfo.token,
        gymId,
        payload: {
          gymStatus: gymStatus,
        },
      }).unwrap();
      refetch();
      toast.success("Gym Status updated successfully");
      setShowDeviceModal(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Button
        variant="outline-secondary"
        style={{ marginBottom: "1rem" }}
        onClick={() => navigate("/allGyms")}
      >
        Back
      </Button>
      <br />
      <label>
        <strong>GymProfileScreen</strong>
      </label>
      <div>
        <ReUsableModal
          title="Edit Biometric Device IDs"
          show={showDeviceModal}
          onHide={() => setShowDeviceModal(false)}
          onSubmit={handleSubmit}
          submit="Update"
          payload={[
            {
              fieldName: "Biometric Device IDs",
              fieldType: "text",
              fieldValue: deviceIds,
              setMethod: setDeviceIds,
              helperText: "Enter IDs separated by commas 1001,abc,1003",
            },
          ]}
        />
        <ReUsableModal
          title="Edit Gym Status"
          show={showStatusModal}
          onHide={() => setShowStatusModal(false)}
          onSubmit={handleStatusSubmit}
          submit="Update"
          payload={[
            {
              fieldName: "GymStatus",
              fieldType: "select",
              fieldValue: gymStatus,
              isMandatory: true,
              notAllowedValues: ["Select Status"],
              options: [
                "Select Status",
                "Verified",
                "Un_Verified",
                "Blocked",
                "Suspected_Duplicate",
              ],
              setMethod: setGymStatus,
            },
          ]}
        />
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message>{error?.data?.error}</Message>
        ) : (
          <>
            {" "}
            <Row style={{ marginTop: "1.5rem" }}>
              <Col md={6}>
                <Card>
                  <ListGroup>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Gym Id</strong>
                        </Col>
                        <Col>{gym?.gymId?._id}</Col>
                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Gym Name</strong>
                        </Col>
                        <Col>{gym?.gymId?.name}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Owner Name</strong>
                        </Col>
                        <Col>{gym?.gymId?.ownerName}</Col>
                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Gym Status</strong>
                        </Col>
                        <Col>
                          {gym?.gymId?.gymStatus ? gym?.gymId?.gymStatus : "-"}{" "}
                          <span
                            style={{
                              color: "#0d6efd",
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontWeight: "500",
                              marginLeft: "2rem",
                            }}
                            onClick={handleStatusEdit}
                          >
                            Edit
                          </span>
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Email</strong>
                        </Col>
                        <Col>{gym?.gymId?.email}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Gym Type</strong>
                        </Col>
                        <Col>{gym?.gymId?.gymType}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Contact Number</strong>
                        </Col>
                        <Col>{gym?.gymId?.primaryContact}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Alternate Number</strong>
                        </Col>
                        <Col>
                          {gym?.gymId?.secondaryContacts?.length
                            ? gym.gymId?.secondaryContacts.join(", ")
                            : "-"}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Address</strong>
                        </Col>
                        <Col>{gym?.gymId?.address}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Pincode</strong>
                        </Col>
                        <Col>{gym?.gymId?.pincode}</Col>
                      </Row>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              </Col>
              <Col md={6}>
                <Card>
                  <ListGroup>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Subscription Type</strong>
                        </Col>
                        <Col>{gym?.gymId?.subscriptionType}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Payment Cycle</strong>
                        </Col>
                        <Col>{gym?.gymId?.paymentCycle}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Subscription Amount</strong>
                        </Col>
                        <Col>₹{gym?.gymId?.subsAmount}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Paid Amount</strong>
                        </Col>
                        <Col>₹{gym?.gymId?.paidAmount}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Due Amount</strong>
                        </Col>
                        <Col>₹{gym?.gymId?.dueAmount}</Col>
                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Admission Fee</strong>
                        </Col>
                        <Col>
                          {gym?.gymId?.admissionFee != null
                            ? `₹${gym.gymId?.admissionFee}`
                            : "-"}
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Renewed Date</strong>
                        </Col>
                        <Col>{gym?.gymId?.subsRenewedDate?.split("T")[0]}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Expiry Date</strong>
                        </Col>
                        <Col>{gym?.gymId?.subsExpiryDate?.split("T")[0]}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>Biometric Device Id</strong>
                        </Col>
                        <Col>
                          {" "}
                          {gym?.gymId?.boxtelDeviceIds?.length
                            ? gym.gymId?.boxtelDeviceIds.join(", ")
                            : "-"}
                          {""}
                          <span
                            style={{
                              color: "#0d6efd",
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontWeight: "500",
                              marginLeft: "2rem",
                            }}
                            onClick={handleEdit}
                          >
                            Edit
                          </span>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              </Col>
            </Row>
            <Row style={{ marginTop: "1.5rem" }}>
              <strong>WhatsApp Notifications</strong>
              <Col md={6}>
                <Card>
                  <ListGroup>
                    <ListGroup.Item>
                      <Row className="align-items-center">
                        <Col md={6}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={gym?.wsInActiveReminder || false}
                              disabled
                            />
                            <span>
                              <strong>Inactive Reminder</strong>
                            </span>
                          </div>
                        </Col>
                        <Col md={6}>
                          <strong>Reminder Days : </strong>
                          {gym?.wsInActiveReminderInDays ?? "-"}
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row className="align-items-center">
                        <Col md={6}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={gym?.wsRenewalReminder || false}
                              disabled
                            />
                            <span>
                              <strong>Renewal Remainder</strong>
                            </span>
                          </div>
                        </Col>
                        <Col md={6}>
                          <strong>Reminder Days : </strong>
                          {gym?.wsRenewalReminderIndays ?? "-"}
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row className="align-items-center">
                        <Col md={6}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={gym?.wsSubscriptionNotification || false}
                              disabled
                            />
                            <span>
                              <strong>
                                WhatsApp Subscription Notification
                              </strong>
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row className="align-items-center">
                        <Col md={6}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={
                                gym?.smsSubscriptionNotification || false
                              }
                              disabled
                            />
                            <span>
                              <strong>SMS Subscription Notification</strong>
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col md={6}>
                          <strong>WhatsApp Message Balance</strong>
                        </Col>
                        <Col md={6}>{gym?.wsMessageBalance ?? "-"}</Col>
                      </Row>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default GymProfileScreen;
